/* eslint-disable react/jsx-wrap-multilines */
import React, { FC, useRef } from 'react';
import { connect } from 'react-redux';

import { toggleShowServices } from '@store/actions';
import { TRACK_SERVICE_SELECT } from '../../services/stats';
import {
  structuredSelector,
  StructuredSelectorProps,
} from './structuredSelector';

import st from './ServiceListFilter.module.css';
import './customStyle.css';
import 'react-custom-scroll/dist/customScroll.css';

import Service from '../OfficeInfo/private/Service';

interface ServiceListFilterProps extends StructuredSelectorProps {
  service: ServiceTypeProps;
  handleSetTarget: () => void;
  toggleShowServices: (payload?: any) => any;
}

const ServiceListFilter: FC<ServiceListFilterProps> = ({
  service,
  handleSetTarget,
  toggleShowServices,
}) => {
  const buttonRef = useRef(null);
  return (
    <div className={st.container}>
      <div className={st.containerHeader}>
        <div className={st.containerTitle}>Услуги МФЦ</div>
      </div>
      {service ? (
        <Service
          service={service}
          onCatalogOpen={() => toggleShowServices(true)}
        />
      ) : (
        <button
          ref={buttonRef}
          className={st.linkBtn}
          type="button"
          data-testid="openModalButton"
          onClick={() => {
            TRACK_SERVICE_SELECT();
            toggleShowServices(true);
            if (handleSetTarget) handleSetTarget();
          }}
        >
          Выбрать услугу из каталога
        </button>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  toggleShowServices: (payload) => dispatch(toggleShowServices(payload)),
});

export default connect(
  structuredSelector,
  mapDispatchToProps
)(ServiceListFilter);
